(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pflegekauf-mengenwahl"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pflegekauf-quantity')) {
    customElements.define('pflegekauf-quantity', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root) return;
        this.stock = JSON.parse(this.querySelector('[data-pk-stock]').textContent);
        this.sync = () => {
          const input = this.root.querySelector('input.quantity__input[name="quantity"]');
          if (!input) return;
          const min = Number(input.min || 1);
          const variantId = this.root.querySelector('product-form input[name="id"]')?.value;
          const variant = this.stock[variantId];
          const stockMax = variant?.tracked ? Math.max(0, variant.quantity - Number(input.dataset.cartQuantity || 0)) : Infinity;
          const ruleMax = input.dataset.max ? Math.max(0, Number(input.dataset.max) - Number(input.dataset.cartQuantity || 0)) : Infinity;
          const max = Math.min(ruleMax, stockMax);
          if (Number.isFinite(max)) {
            if (input.max !== String(max)) input.max = String(max);
          } else if (input.hasAttribute('max')) {
            input.removeAttribute('max');
          }
          input.setCustomValidity('');
          if (input.validity.rangeOverflow) input.setCustomValidity(this.dataset.quantityUnavailable);
          const step = Number(input.step || 1);
          this.querySelectorAll('button[data-quantity]').forEach(button => {
            const value = Number(button.dataset.quantity);
            button.disabled = !variant?.available || value < min || value > max || (value - min) % step !== 0;
            button.setAttribute('aria-pressed', String(value === Number(input.value)));
          });
        };
        this.choose = event => {
          const button = event.target.closest('button[data-quantity]');
          const input = this.root.querySelector('input.quantity__input[name="quantity"]');
          if (!button || !this.contains(button) || button.disabled || !input) return;
          input.value = button.dataset.quantity;
          input.dispatchEvent(new Event('change', {bubbles: true}));
          this.sync();
        };
        this.validate = event => {
          const input = this.root.querySelector('input.quantity__input[name="quantity"]');
          if (!input || event.target !== input.form) return;
          this.sync();
          if (!input.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            input.reportValidity();
          }
        };
        this.root.addEventListener('submit', this.validate, true);
        this.addEventListener('click', this.choose);
        this.root.addEventListener('change', this.sync);
        this.root.addEventListener('input', this.sync);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.root, {subtree:true, childList:true, attributes:true, attributeFilter:['min','max','step','data-max','data-cart-quantity']});
        this.sync();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.choose);
        this.root?.removeEventListener('submit', this.validate, true);
        this.root?.removeEventListener('change', this.sync);
        this.root?.removeEventListener('input', this.sync);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
